import { Component, Input } from '@angular/core';
import { Business } from '../models/business.model';
import { AirportService } from '../../airport/airport.service';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';

@Component({
  selector: 'app-fees-section',
  templateUrl: './fees-section.component.html',
  styleUrls: ['./fees-section.component.scss']
})
export class FeesSectionComponent implements IConditionalSection {

  @Input() business: Business;
  isEditModeSet: boolean;

  constructor(private _toggleService: EditToggleService) {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.isEditModeSet = isOn;
    });
  }

  get hasContent(): boolean {
    return AirportService.shouldShowFees(this.business);
  }

}
